define('view/people/user.account.component',['require','exports','module','uikit/uikit','blockit'],function(require, exports, module) {
  //prettier-ignore
  var UIKit   = require('uikit/uikit'),
      BlocKit = require('blockit');

  var UserAccountComponent = {
    type: BlocKit.AttachedComponentsContainerView,
    components: [
      {
        type: BlocKit.ContentActionsHeaderView,
        header: {
          text: 'User Account',
        },
      },
      {
        type: BlocKit.BasicTableView,
        collection: '@resources.personUserCollection',
        emptyText: 'No linked account.',
        selectable: false,
        columns: [
          {
            text: 'Account',
            data: 'username',
          },
        ],
      },
    ],
  };

  module.exports = UserAccountComponent;
});

